import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard  {
  token: any;
  constructor(
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {
    if (window.location.href.includes('?')) {
      const queryString = window.location.href.split('?')[1];
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has('accessToken')) {
        this.token = urlParams.get('accessToken');
      }

      // This idToken needed for entra logout
      if (urlParams.has('idToken')) {
        const idToken = urlParams.get('idToken');
        if (idToken) { 
          localStorage.setItem('idToken', idToken);
        }
      }
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let loginType = environment.loginType;

    const currentUser = this.authService.currentUserValue;
    if (currentUser == null || Object.keys(currentUser).length === 0) {
      if (loginType !== 'SSO') {
        // logged in so return true
        return true;
      } else {
        if (this.token) {
          sessionStorage.setItem(
            'currentUser',
            JSON.stringify({ accessToken: this.token })
          );
          this.profileData();
          return false;
        } else {
          if (environment.USE_LEGACY_PING_SSO) {
            window.location.href = environment.PING_SSO_URL;
          } else {
            window.location.href = environment.ENTRA_SSO_URL;
          }
          return false;
        }
      }
    } else {
      this.getRoleAccessForPage(currentUser.roles);
      return false;
    }
  }

  profileData() {
    return this.authService.getProfileData().subscribe(
      (profileData: any) => {
        try {
          if (profileData) {
            let profileDetails = JSON.stringify(profileData);
            sessionStorage.setItem('profileData', profileDetails);
            let profileGetData: any = sessionStorage.getItem('profileData');
            let parseData: any = JSON.parse(profileGetData);
            sessionStorage.setItem(
              'currentUser',
              JSON.stringify({
                accessToken: this.token,
                partners: parseData.partners,
                roles: parseData.roles,
              })
            );
            this.getRoleAccessForPage(profileData.roles);
          }
        } catch (error) {
          sessionStorage.clear();
          localStorage.clear();
          if (environment.USE_LEGACY_PING_SSO) {
            window.location.href = environment.PING_SSO_URL;
          } else {
            window.location.href = environment.ENTRA_SSO_URL;
          }
        }
      },
      (error) => {
        sessionStorage.clear();
        localStorage.clear();
        if (environment.USE_LEGACY_PING_SSO) {
          window.location.href = environment.PING_SSO_URL;
        } else {
          window.location.href = environment.ENTRA_SSO_URL;
        }
      }
    );
  }

  getRoleAccessForPage(roles: Array<Record<string,string>>) {
      const dashboardPageRole = ['admin', 'mhvoucher_superuser', 'mhvoucher_support'];
      const roleNames = roles.map(
        (item: Record<string, string>) => item.role_name,
      );
      if (roleNames?.includes('idadm')) {
        this.router.navigate(['/user-management']);
      } else if (
        dashboardPageRole.some(role => roleNames?.includes(role))
      ) {
        this.router.navigate(['/voucher-dashboard']);
      } else {
        this.router.navigate(['/']);
      }
  }
}
